/**
 * ч.1074: «Адміністрування акаунта» → «Безпека» — обовʼязковий двофакторний
 * вхід і довірені мережі (IP). Читати — власник і адміністратор, змінювати —
 * лише власник (бекенд: api/v1/tenant_security.py).
 */
import { api } from './client';

export interface MemberSecurity {
  membership_id: string;
  user_id: string;
  email: string;
  full_name: string;
  tenant_role: 'OWNER' | 'ADMIN' | 'MEMBER';
  status: 'ACTIVE' | 'SUSPENDED' | 'INVITED';
  has_two_factor: boolean;
  /** Особисті позначки (власника не стосуються). */
  require_two_factor: boolean;
  ip_restricted: boolean;
  /** Що фактично діє з урахуванням загальних налаштувань. */
  two_factor_required: boolean;
  networks_restricted: boolean;
  personal_networks: number;
}

export interface TrustedNetwork {
  id: string;
  network: string;
  label: string | null;
  /** null — спільна для всіх користувачів з обмеженням. */
  user_id: string | null;
  user_email: string | null;
  created_at: string;
}

export interface BlockedAttempt {
  created_at: string;
  user_email: string;
  reason: 'TWO_FACTOR_REQUIRED' | 'IP_NOT_ALLOWED';
  ip: string | null;
}

export interface TenantSecurity {
  require_two_factor: boolean;
  ip_restrict_all: boolean;
  can_edit: boolean;
  me: { has_two_factor: boolean; session_verified: boolean; client_ip: string | null };
  members: MemberSecurity[];
  networks: TrustedNetwork[];
  blocked: BlockedAttempt[];
}

export const tenantSecurity = {
  get: () => api.get<TenantSecurity>('/tenant-security').then((r) => r.data),
  set: (body: { require_two_factor: boolean; ip_restrict_all: boolean }) =>
    api.put<TenantSecurity>('/tenant-security', body).then((r) => r.data),
  setMember: (membershipId: string,
    body: { require_two_factor?: boolean; ip_restricted?: boolean }) =>
    api.put<TenantSecurity>(`/tenant-security/members/${membershipId}`, body)
      .then((r) => r.data),
  /** ч.1075: `network` — одна або кілька адрес/мереж через кому. */
  addNetwork: (body: { network: string; label?: string | null; user_id?: string | null }) =>
    api.post<TenantSecurity & { added: string[]; already: string[] }>(
      '/tenant-security/networks', body).then((r) => r.data),
  deleteNetwork: (id: string) =>
    api.delete<TenantSecurity>(`/tenant-security/networks/${id}`).then((r) => r.data),
  remind2fa: () =>
    api.post<{ notified: number }>('/tenant-security/remind-2fa').then((r) => r.data),
};
